<template>
  <div>
    <p>
      The minimum station in-visibility duration yields for the minimum time a
      satellite have to spend within a ground station field of view to
      communicate with it.
    </p>
    <p>
      This duration is taken into account to compute the forward link transfer
      time and the reverse link transfer time metrics. Moreover, station
      visibilities shorter than this minimum duration are not taken into
      account.
    </p>
    <p>
      <v-img
        contain
        :src="
          require('../../../assets/images/tooltip-constellation-outputs.png')
        "
        aspect-ratio="1.6"
      />
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationMinimumStationVisibilityDuration'
}
</script>
